import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { OeAppService } from './oe-app.service';

@Injectable()
export class KeepAliveService {
  constructor(private http: HttpClient, private oeAppService: OeAppService) {}

  fetchServerTime(): Observable<number> {
    const url = `${this.oeAppService.oeProgressServiceHost}/v1/keepalive/time`;
    return this.http.get<number>(url);
  }
}



// WEBPACK FOOTER //
// ./ts/app/shared/keep-alive.service.ts